<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                productForm: () => import('../forms/ProductForm'),
                fields: [
                    { type: 'autocomplete', text: 'Product', value: 'productId', rules: [v => !!v || 'Product is required'], isRequired: true, form: () => import('./ProductForm'), apiMethod: 'Products', claim: 'Products' },
                    { type: 'text', text: 'Batch Number', value: 'batchNumber', rules: [v => !(v && v.length > 100) || 'Batch Number must be less than 100 characters'], maxLength: 100 },
                    { type: 'number', text: 'Price', value: 'price', rules: [] },
                    { type: 'text', text: 'Client Name', value: 'clientName', rules: [v => !(v && v.length > 100) || 'Client Name must be less than 100 characters'], maxLength: 100 },
                    { type: 'datetime', text: 'Packed On', value: 'packedOn', rules: [v => !!v || 'Packed On is required'], isRequired: true },
                    { type: 'datetime', text: 'Dispatched On', value: 'dispatchedOn', rules: [v => !!v || 'Dispatched On is required'], isRequired: true },
                    { type: 'datetime', text: 'Expires On', value: 'expiresOn', rules: [] },
                    { type: 'text', text: 'Pack Format', value: 'packFormat', rules: [v => !(v && v.length > 100) || 'Pack Format must be less than 100 characters'], maxLength: 100 },
                ],
                apiMethod: 'ProductDispatches',
                formTitle: 'Product Dispatch',
            }
        },
    };
</script>
